import request from './index';

export function addDevice(data) {
  return request.post('officialPageDevice/add', data);
}

export function updateDevice(data) {
  return request.post('officialPageDevice/update', data);
}

export function deleteDevice(id) {
  return request.post('officialPageDevice/delete', { id });
}

export function getDeviceDetail(id) {
  return request.get('officialPageDevice/detail', { params: { id } });
}

export function getDevicePage(params) {
  return request.get('officialPageDevice/page', { params });
}

export function getDeviceList(params) {
  return request.get('officialPageDevice/list', { params });
}
